module.exports = __webpack_public_path__ + "static/media/Imagem_conte_C3_BAdo_fixado_web_402x.4c2dc803.png";